import LivePlayer from '@een/live-video-web-sdk';
import React, { useEffect, useRef, useState } from 'react';
import Loader from '@rsos/components/capstone/Loader';
import { FullAbsolute, Player } from './EagleEyeVideo.styles';
import { useVideoEventListeners } from './helpers';

const EagleEyePlayer = ({ token, baseUrl, cameraId, fullscreenRef }) => {
  const [isPlayerLoading, setIsPlayerLoading] = useState(true);
  const videoRef = useRef(null);

  // Configuration
  useEffect(() => {
    const config = {
      videoElement: videoRef.current,
      cameraId: cameraId,
      baseUrl: baseUrl,
      jwt: token,
    };
    const player = new LivePlayer();
    player.start(config);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useVideoEventListeners(videoRef, setIsPlayerLoading, cameraId);

  return (
    <Player width="100%" position="relative" ref={fullscreenRef}>
      <video
        ref={videoRef}
        autoPlay
        muted
        controls
        width="100%"
        height="100%"
        disablePictureInPicture
      />
      {isPlayerLoading && (
        <FullAbsolute>
          <Loader noText fluid dataName="player-loader" />
        </FullAbsolute>
      )}
    </Player>
  );
};

export default EagleEyePlayer;
